import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import Paggination from "../Paggination";
import Loader from "../Loader/Loader";
import { formatDateInAMPM } from "../../utils/helper";

import { STANDARD_IMAGE_URL } from "../../utils/constant";

const NftListLayer = () => {
  const { AsyncGetApiCall, AsyncPostApiCall } = useApi();
  const navigate = useNavigate();
  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: 50,
    search: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const setPageNo = (pageNo) => {
    setQuery((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
  };

  const getAllNftList = async (/* showLoader = true */) => {
    try {
      // if (showLoader) {
      setLoading(true);
      // }
      console.log("query...", query);
      const result = await AsyncGetApiCall("/nft/list-in-admin", query);
      console.log("Result:", result);

      if (result?.success) {
        setData(result || []);
      } else {
        toast.error(result?.message || "Failed to fetch NFT data");
      }
    } catch (error) {
      console.log("error...", error);
    } finally {
      // if (showLoader) {
      setLoading(false);
      // }
    }
  };

  const handleViewNftCollection = (id) => {
    navigate(`/view-nft-collection/${id}`);
  };

  const handleSearchAirdrop = (e) => {
    const value = e.target.value;
    // const validChars = /^[a-zA-Z0-9]*$/;
    const validChars = /^[a-zA-Z0-9\s]*$/;

    if (validChars.test(value)) {
      setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    console.log("value...", value);
    setQuery((prev) => ({
      ...prev,
      status:
        value === ""
          ? ""
          : value === "Approved"
          ? "approved"
          : value === "Pending"
          ? "pending"
          : "",
      pageNo: 1,
    }));
  };

  const handleActivateNft = async (id, isApproved) => {
    console.log("id...", id);
    console.log("isApproved...", isApproved);

    try {
      setLoading(true);
      const payload = {
        nftId: id,
        status: isApproved,
      };
      const result = await AsyncPostApiCall(`/nft/status-manage`, payload);
      console.log("result...", result);
      if (result?.success) {
        toast.success(
          result?.message ||
            `NFT ${
              result?.data?.isApproved ? "activated" : "deactivated"
            } successfully`
        );
        getAllNftList();
      } else {
        toast.error(result?.message || "Something went wrong");
      }
    } catch (error) {
      console.log("error...", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllNftList();
  }, [query]);

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <span className="text-md fw-medium text-secondary-light mb-0">
              Show
            </span>
            <select
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={query.limitVal}
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                setQuery((prev) => ({
                  ...prev,
                  limitVal: value,
                  pageNo: 1,
                }));
              }}>
              {Array.from({ length: 20 }, (_, i) => {
                const value = (i + 1) * 5;
                return (
                  <option key={value} value={value}>
                    {value}
                  </option>
                );
              })}
            </select>
            <form className="navbar-search" onSubmit={handleFormSubmit}>
              <input
                type="text"
                className="bg-base h-40-px w-35"
                name="search"
                placeholder="Search NFT by title, description"
                onChange={handleSearchAirdrop}
                value={query.search}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>
            <span className="text-md fw-medium text-secondary-light mb-0">
              Status
            </span>
            <select
              name="status"
              id="status"
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={
                query.status === "approved"
                  ? "Approved"
                  : query.status === "pending"
                  ? "Pending"
                  : ""
              }
              onChange={handleStatusChange}>
              <option value="">Select Status</option>
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
            </select>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      S.No
                    </div>
                  </th>
                  <th scope="col">Title</th>
                  <th scope="col">Description</th>
                  <th scope="col">Royalty</th>

                  <th scope="col">Date</th>
                  <th scope="col">Status</th>
                  <th scope="col" className="text-center">
                    Activate
                  </th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.data && data?.data?.length > 0 ? (
                  data?.data?.map((nft, index) => (
                    <tr key={nft._id}>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-10">
                          {(data?.currentPage - 1) * query.limitVal + index + 1}
                        </div>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {nft?.image && (
                            <img
                             
                              src={nft?.image ? nft?.image : STANDARD_IMAGE_URL}
                              alt="NFT"
                              className="w-40-px h-40-px flex-shrink-0 me-12 overflow-hidden nft-border-radius"
                            />
                          )}
                          {nft?.title}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {nft?.description.length > 10
                            ? nft?.description.slice(0, 10) + "..."
                            : nft?.description}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {nft?.royaltyBps}%
                        </span>
                      </td>

                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {formatDateInAMPM(nft?.createdAt)}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            nft?.isApproved
                              ? "bg-success-100 text-success-600"
                              : "bg-warning-100 text-warning-600"
                          } text-sm py-4 px-10 radius-4`}>
                          {nft?.isApproved ? "Active" : "Pending"}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`toggle-${nft._id}`}
                              checked={nft?.isApproved}
                              onChange={() => {
                                if (
                                  window.confirm(
                                    "Are you sure you want to change the status of this NFT?"
                                  )
                                ) {
                                  handleActivateNft(nft?._id, !nft?.isApproved);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <button
                            type="button"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => navigate(`/nft-view/${nft?._id}`)}>
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                            <span className="tooltip-text">View</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No nfts found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paggination
            total={data?.total || 0}
            totalPages={data?.totalPages || 0}
            currentPage={data?.currentPage || 0}
            setPageNo={setPageNo}
            startFrom={(data?.currentPage - 1) * query.limitVal + 1}
            endTo={
              (data?.currentPage - 1) * query.limitVal + data?.data?.length
            }
          />
        </div>
      </div>
    </>
  );
};

export default NftListLayer;
